import { createStore } from 'vuex'
import { auth } from './auth/auth'
import { cvbuilder } from './cvbuilder/cvbuilder'
import {employerVacancies} from './employers/employerVacancies'
import { profile } from './profile/userProfile' 
import { jobs } from './public/jobs'
import { search } from './public/search'
import { jobApplicants } from './employers/jobApplicants'
import { administrator } from './admin/administrator'


export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,cvbuilder,employerVacancies,profile,jobs,jobApplicants,administrator,search
  }
})
